module.exports = __webpack_public_path__ + "img/pic_australia_07.a066abf0.jpg";